module.exports = __webpack_public_path__ + "static/media/6-1.5e84703f.webp";